import type { FC } from 'react';

import CheckboxGroup from '../../fields/checkbox_group/checkbox_group';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = [
  'labelWidth',
  'labelClassName',
  'checkboxClassName',
  'componentWrapper',
  'options',
  'checkboxLabelClassName',
] as const;

const Field = formField(CheckboxGroup, {
  defaultValue: [],
  transformProps: (props) => pickProps(props, componentProps),
});

export type CheckboxGroupFieldWrapperProps = FieldWrapperProps<typeof Field>;

const CheckboxGroupFieldWrapper: FC<CheckboxGroupFieldWrapperProps> = (
  props,
) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default CheckboxGroupFieldWrapper;
